import { ROLES, SCOPES, USER_RIGHTS, WRITE_SCOPES } from 'business/constants';
import {
    GenderType,
    ScopeT,
    SelectionBaseT,
    UserInfoT,
    UserRole,
    UserT,
} from 'business/definitions';
import { BudgetResourceType } from 'helpers/userRights/types';

export const USER_CREATION_FORM_ACTION_TYPE = {
    addRole: 'ADD_ROLE',
    changeAuthMethod: 'CHANGE_AUTH_METHOD',
    removeBlockValueFromScope: 'REMOVE_BLOCK_VALUE_FROM_SCOPE',
    removeBlockValueFromWriteScope: 'REMOVE_BLOCK_VALUE_FROM_WRITE_SCOPE',
    removeRole: 'REMOVE_ROLE',
    removeScope: 'REMOVE_SCOPE',
    removeWriteScope: 'REMOVE_WRITE_SCOPE',
    updateGender: 'UPDATE_GENDER',
    updateScopeAccessType: 'UPDATE_SCOPE_ACCESS_TYPE',
    updateWriteScopeAccessType: 'UPDATE_WRITE_SCOPE_ACCESS_TYPE',
    updateScopeBlockValues: 'UPDATE_SCOPE_BLOCK_VALUES',
    updateWriteScopeBlockValues: 'UPDATE_WRITE_SCOPE_BLOCK_VALUES',
    updatePersonalInformation: 'UPDATE_PERSONAL_INFORMATION',
} as const;

type UpdatePersonalInformationPayloadT = {
    email?: string;
    firstname?: string;
    job?: string;
    lastname?: string;
};

export type UserCreationFormAction =
    | {
          type: 'ADD_ALL_USER_RIGHTS';
          availableGestionnaires: { value: string; label: string }[];
          availableOrgChartFinance: { value: string; label: string }[];
      }
    | { type: 'ADD_ROLE'; role: UserRole }
    | {
          type: 'ADD_USER_RIGHTS';
          newRights: string[];
          resourceType: BudgetResourceType;
          tree: TreeT;
      }
    | { type: 'CHANGE_AUTH_METHOD'; authMethod: string }
    | {
          type: 'INITIALIZE_USER_RIGHTS_FOR_RESOURCE';
          resources: { value: string; label: string }[];
          resourceType: BudgetResourceType;
      }
    | {
          type: 'REMOVE_ALL_USER_RIGHTS';
          availableGestionnaires: { value: string; label: string }[];
          availableOrgChartFinance: { value: string; label: string }[];
      }
    | {
          type: 'REMOVE_BLOCK_VALUE_FROM_SCOPE';
          scope: ScopeT;
          blockName: string;
          blockValue: SelectionBaseT;
      }
    | {
          type: 'REMOVE_BLOCK_VALUE_FROM_WRITE_SCOPE';
          scope: ScopeT;
          blockName: string;
          blockValue: SelectionBaseT;
      }
    | { type: 'REMOVE_ROLE'; role: UserRole }
    | { type: 'REMOVE_WRITE_SCOPE'; writeScope: ScopeT }
    | { type: 'REMOVE_SCOPE'; scope: ScopeT }
    | {
          type: 'REMOVE_USER_RIGHT';
          resourceSoftwareId: string;
          resourceType: BudgetResourceType;
          tree: TreeT;
      }
    | { type: 'UPDATE_GENDER'; gender: GenderType }
    | {
          type: 'UPDATE_SCOPE_BLOCK_VALUES';
          scope: ScopeT;
          blockName: string;
          blockValues: SelectionBaseT[];
      }
    | {
          type: 'UPDATE_WRITE_SCOPE_BLOCK_VALUES';
          scope: ScopeT;
          blockName: string;
          blockValues: SelectionBaseT[];
      }
    | { type: 'UPDATE_SCOPE_ACCESS_TYPE'; scope: ScopeT }
    | { type: 'UPDATE_WRITE_SCOPE_ACCESS_TYPE'; writeScope: ScopeT }
    | {
          type: 'UPDATE_PERSONAL_INFORMATION';
          payload: UpdatePersonalInformationPayloadT;
      };

export type UserCreationFormState = UserInfoT &
    Pick<
        UserT,
        | 'authMethods'
        | typeof ROLES
        | typeof SCOPES
        | typeof WRITE_SCOPES
        | typeof USER_RIGHTS
    >;
